var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWasteicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 113,
    viewBox: "0 0 111 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M60.4995 29.7002C56.7995 28.4002 53.5999 29.3002 48.8999 30.7002C48.0999 30.9002 46.3999 31.3998 44.8999 32.7998C43.9999 33.5998 43.3999 34.1998 43.3999 34.7998C43.2999 37.0998 48.2993 39.3994 55.2993 39.3994C60.0993 39.3994 66.7991 37.7996 67.0991 35.0996C67.1991 32.7996 62.9995 30.5002 60.4995 29.7002Z",
    fill: "#193666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M0 52.8C1.5 130.3 114.7 131.8 109.8 57.2004C115.5 -15.3996 11.2 -20.2 0 52.8ZM71.2998 40.0002C71.1998 39.9002 72.3996 84.9998 66.5996 84.5998C33.9996 85.8998 42.1996 94.1996 38.5996 40.8996C16.2996 26.1996 72.1 17.0002 75 34.5002C75 36.6002 73.5998 38.4002 71.2998 40.0002Z",
    fill: "#193666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteicon);
export default __webpack_public_path__ + "static/media/wasteicon.7c29515278dfb4a0e8f204611e56672c.svg";
export { ForwardRef as ReactComponent };